export default __webpack_public_path__ + "static/media/icons8_3rd_place_medal 1.082e68ec.svg";